import { isEqual } from 'lodash'
import { deepEquals } from './deepEquals'
import { DEFAULT_LIMITS, DEFAULT_OFFSET, LAST_OFFSET } from '@/const'
import type { Promisable } from '@/types'

// offset 분리 필요
type ExecutingFunctionInfo<T extends (arg: any) => Promisable<any>> = {
  // executingFunctionName?: string
  params: Parameters<T>[0]
  offset: number
}

/**
 * 함수가 parameter 를 한개만 가지고, paramter 가 object 로 올거라고 생각하고 만들어진 클래스입니다.
 */
export class OffsetSettingInfoList<T extends (arg: any) => Promisable<any>> {
  private offsetList: ExecutingFunctionInfo<T>[] = []
  /**
   * paramter 가 같은 함수의 offset 출력
   */
  checkLimit(info: ExecutingFunctionInfo<T>, currentDatalength: number = 0) {
    const currentOffset = this.findExecutingFunctionOffsetInfo(info)

    if (currentOffset.offset === LAST_OFFSET) return currentOffset.offset
    if (currentOffset.offset && currentDatalength >= DEFAULT_LIMITS) {
      currentOffset.offset++
    } else {
      currentOffset.offset = LAST_OFFSET
    }
    return currentOffset.offset
  }

  removeOffset(params: Parameters<T>[0]) {
    this.offsetList = this.offsetList.filter((offset) => {
      return !isEqual(offset.params, params)
    })
  }

  /**
   *
   */
  offsetSettingInfo(info: ExecutingFunctionInfo<T>) {
    if (!Object.keys(info.params).includes('needToAddData')) return LAST_OFFSET
    if (!info.offset) info.offset = 1
    const useCheckSameValue = this.findExecutingFunctionOffsetInfo(info)
    if (useCheckSameValue.offset === -1) {
      this.offsetList.push(info)
      return DEFAULT_OFFSET
    }

    return useCheckSameValue.offset
  }

  findExecutingFunctionOffsetInfo(info: ExecutingFunctionInfo<T>) {
    const index = this.offsetList.findIndex((item) =>
      deepEquals(item.params, info.params),
    )
    if (index === -1) return { offset: -1 }
    return this.offsetList[index]
  }
}
